export default __webpack_public_path__ + "static/website-1711f78d45f70627d2d038f23eca94a5.jpg";